import { timestampToHumanReadable } from "../../utils/timestampToHumanReadable";

const initialCacheState = {
  lastCachedAt: null,
};

function cacheReducer(state = initialCacheState, action) {
  switch (action.type) {
    case 'CACHE_RESPONSE':
      return {
        ...state,
        [action.payload.url]: action.payload.response,
        lastCachedAt: timestampToHumanReadable(Date.now())
      };
    default:
      return state;
  }
}

export default cacheReducer;
